<template>
    <v-dialog max-width="600px" persistent v-model="dialog">
        <v-card>
            <v-card-title>
                <h3>일정 추가</h3>
            </v-card-title>
            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-text-field label="일정" v-model="calendar.title" prepend-icon="mdi-folder-marker"></v-text-field>
                    <v-textarea label="상세설명" v-model="calendar.contents" prepend-icon="mdi-pencil"></v-textarea>
                    <v-row>
                        <v-col cols="6" class="pb-0">
                            <v-menu>
                                <template v-slot:activator="{on}">

                                    <v-text-field slot="activator" label="시작일"
                                                  readonly
                                                  prepend-icon="mdi-calendar-month"
                                                  v-on="on" :value="calendar.startDate"
                                                  class=""></v-text-field>
                                </template>
                                <v-date-picker v-model="calendar.startDate"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="6" class="pb-0">
                            <v-menu
                                    :close-on-content-click="false"
                                    v-model="startTimer"
                                    offset-y
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            label="시작 시간"
                                            readonly
                                            :value="calendar.startTime"
                                            prepend-icon="mdi-timer"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                        v-if="startTimer"
                                        v-model="calendar.startTime"
                                >
                                    <v-btn class="mx-auto"
                                           @click="selectTime"
                                    >선택
                                    </v-btn>
                                </v-time-picker>
                            </v-menu>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="6" class="pt-0">
                            <v-menu>
                                <template v-slot:activator="{on}">

                                    <v-text-field slot="activator" label="종료일"
                                                  readonly
                                                  prepend-icon="mdi-calendar-month"
                                                  v-on="on" :value="calendar.endDate"
                                                  class=""></v-text-field>
                                </template>
                                <v-date-picker v-model="calendar.endDate"
                                               :allowed-dates="allowedDates"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="6" class="pt-0">
                            <v-menu
                                    :close-on-content-click="false"
                                    v-model="endTimer"
                                    offset-y
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            label="종료 시간"
                                            readonly
                                            :value="calendar.endTime"
                                            prepend-icon="mdi-timer"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                        v-if="endTimer"
                                        v-model="calendar.endTime"
                                >
                                    <v-btn class="mx-auto"
                                           @click="selectTime"
                                    >선택
                                    </v-btn>
                                </v-time-picker>
                            </v-menu>
                        </v-col>
                    </v-row>

                    <div class="text-center">
                        <v-btn text class="primary white--text mx-2 mt-3" @click="submit">
                            추가
                        </v-btn>
                        <v-btn text class="primary white--text mx-2 mt-3" @click="close">
                            닫기
                        </v-btn>
                    </div>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      startTimer: false,
      endTimer: false,
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1']
    }
  },
  computed: {
    dialog () {
      return this.$store.state.home.calendar.dialog
    },
    calendar () {
      return this.$store.state.home.calendar
    }
  },
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.setEvent()
      }
    },
    close () {
      this.$store.commit('home/closeCalendarDialog')
    },
    selectTime () {
      this.endTimer = false
      this.startTimer = false
    },
    allowedDates (val) {
      const endDate = val.split('-').reduce((a, b) => a + b)
      const startDate = this.calendar.startDate.split('-').reduce((a, b) => a + b)
      return endDate >= startDate
    },
    formatDate (date) {
      const d = new Date(date)
      let month = '' + (d.getMonth() + 1)
      let day = '' + d.getDate()
      const year = d.getFullYear()
      let hour = d.getHours()
      let min = d.getMinutes()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      if (hour.length < 2) hour = '0' + hour
      if (min.length < 2) min = '0' + min

      return [year, month, day].join('-') + ' ' + [hour, min].join(':')
    },
    setEvent () {
      const start = new Date(`${this.calendar.startDate}T${this.calendar.startTime}`)
      const end = new Date(`${this.calendar.endDate}T${this.calendar.endTime}`)

      const event = {
        name: this.calendar.title,
        details: this.calendar.contents,
        color: this.colors[this.rnd(0, this.colors.length - 1)],
        start: this.formatDate(start),
        end: this.formatDate(end),
        timed: true
      }
      this.$store.commit('home/addEvent', event)
      this.$store.dispatch('home/updateEventList')
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    }
  }

}
</script>
